export default __webpack_public_path__ + "static/media/storage_types.7174c650.png";